import { createSyncRunner } from '../platform/sync-runner';
import { sdb, SCHAAK_TABLE_MAP } from './db';

/** The schaak sync loop — the platform runner bound to this module's own store. */
export const schaakSync = createSyncRunner({
  endpoint: '/api/v1/schaak/sync',
  db: sdb,
  outbox: sdb.outbox,
  meta: sdb.meta,
  rejections: sdb.rejections,
  tables: SCHAAK_TABLE_MAP,
  sinceKey: 'schaak_since',
  lastOkKey: 'schaak_last_ok',
});

export const startSchaakSync = () => schaakSync.startLoop();
